import { FailedReason } from '@sc/graphql';

// Human-readable copy for a source document's failure, shown in the document
// list and on hover.
export const failedReasonLabel = (reason: FailedReason): string => {
  switch (reason) {
    case FailedReason.emptyContent:
      return 'No content to index';
    case FailedReason.invalidIntegrationDoucment:
      return 'Invalid document';
    case FailedReason.extraction:
      return 'Failed to extract content';
    default:
      return 'Indexing failed';
  }
};
